import withAttachmentsAndMediaFiles from '../withAttachmentsAndMediaFiles';
import BreakbulkPage from './BreakbulkItemListPage';

export const BreakbulkItemListPage = withAttachmentsAndMediaFiles(BreakbulkPage);
export { default as BreakbulkItemDiff } from './BreakbulkItemDiff';
